import { createContext } from 'react'

export const SuiExternalContext = createContext<boolean>(false)
